module.exports = __webpack_public_path__ + "80ccef9733d4f8fa4122105a62f1681d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/deleteDiscount.png
// module id = 111
// module chunks = 0